import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoggerService } from './service/logger.service';
import { NotificationModule } from './notification.module';
import { NotificationService } from './service/notification.service';
import { AuthGaurdService } from './service/auth-gaurd.service';
import { ManageUserService } from './service/manage-user.service';
import { MyLoaderComponent } from './loader/my-loader/my-loader.component';
import { LoaderService } from './service/loader.service';
import { DatePipe } from '@angular/common';
import { ErrorCatchingInterceptor } from './interceptor/error-catching.interceptor';
import { LoaderInterceptor } from './interceptor/loader-interceptor.service';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { SessionTimeoutComponent } from './_components/session-timeout/session-timeout.component';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalService } from '@azure/msal-angular';
import { LogLevel, IPublicClientApplication, PublicClientApplication, BrowserCacheLocation, InteractionType } from '@azure/msal-browser';
import { b2cPolicies, apiConfig } from './home/b2c-config';
import { environment } from 'src/environments/environment';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

const ENV_CLIENTID = environment.clientId;
const ENV_REDIRECTURI = environment.redirectUri;

export function loggerCallback(logLevel: LogLevel, message: string) {
 // console.log("loggerCallback called: "+logLevel + ' - ' + message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: ENV_CLIENTID,
      redirectUri: ENV_REDIRECTURI,
      authority: 'https://login.microsoftonline.com/cf535dc0-73fc-41ea-a174-17f37ced7fe7',
      knownAuthorities: [b2cPolicies.clientSecret]
    },

    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(apiConfig.uri, apiConfig.scopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...apiConfig.scopes],
    },
  };
}

@NgModule({
  declarations: [
    AppComponent,
    MyLoaderComponent,
    SessionTimeoutComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NotificationModule,
    BrowserAnimationsModule,
    MsalModule
  ],

  providers: [NotificationService, AuthGaurdService, ManageUserService, LoggerService, LoaderService, DatePipe, 
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: AuthJavaInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorCatchingInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
